import { Map as ImmutableMap, List } from 'immutable';
import { TABLE } from '../../constants/chartTypes';
import { SEARCH } from '../../constants/configTypes';
//@ts-expect-error Untyped import
import compose from '../../lib/compose';
//@ts-expect-error Untyped import
import { matchCurrencyProcessor } from '../../process';
export const cleanDisplayParams = report => (report.get('displayParams') || ImmutableMap()).delete('checked').delete('columns').delete('customSeries').delete('onRowClick').delete('onRowLinkClick').delete('onClick').delete('onSort').delete('pivot').delete('render').delete('rowsPerPage').delete('showTotals').delete('toggleAllSeries').delete('toggleSeries').delete('showDelta').delete('tableRowExpand').set('drilldown', true);
const transferProcessors = baseReport => config => config.set('processors', (baseReport.getIn(['config', 'processors']) || List()).filter(matchCurrencyProcessor));
const removeConfigArtifacts = config => config.delete('compare').set('offset', 0);
export function buildDrilldownReport(baseReport, generatedConfig, options = {}) {
  if (!generatedConfig) {
    return baseReport;
  }
  const displayParams = cleanDisplayParams(baseReport);
  return ImmutableMap({
    chartType: TABLE,
    config: compose(removeConfigArtifacts, transferProcessors(baseReport))(generatedConfig),
    displayParams: displayParams.set('hideKeyColumn', generatedConfig.get('configType') === SEARCH),
    name: options.name
  });
}